"use client";

import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import { useEffect, useRef } from "react";

import envs from "@/envs.ts";
import { useHasConsentedToAnalytics } from "@/hooks/use-has-consented-to-analytics";

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  const hasConsented = useHasConsentedToAnalytics();
  const initializedRef = useRef(false);

  useEffect(() => {
    if (hasConsented) {
      if (!initializedRef.current) {
        posthog.init(envs.VITE_PUBLIC_POSTHOG_KEY, {
          api_host: envs.VITE_PUBLIC_POSTHOG_HOST,
          ui_host: "https://eu.posthog.com",
          defaults: "2025-05-24",
          capture_exceptions: true,
          persistence: "memory",
          consent_persistence_name: "ximly_cookie_consent.analytics",
          debug: process.env.NODE_ENV === "development",
        });
        initializedRef.current = true;
      }
      try {
        posthog.opt_in_capturing();
      } catch {}
    } else {
      try {
        posthog.opt_out_capturing();
      } catch {}
    }
  }, [hasConsented]);

  if (!hasConsented) return children;
  else return <PHProvider client={posthog}>{children}</PHProvider>;
}
